/** Tracks asynchronous URL restores so a later user navigation cannot rewrite an older entry. */
export function createHistoryRestoreState() {
  let generation = 0;
  let restoring = false;

  return {
    get restoring() {
      return restoring;
    },
    begin() {
      restoring = true;
      return ++generation;
    },
    isCurrent(candidate: number) {
      return candidate === generation;
    },
    cancel() {
      if (!restoring) return;
      generation++;
      restoring = false;
    },
    finish(candidate: number) {
      if (candidate !== generation) return false;
      restoring = false;
      return true;
    },
  };
}
